module.exports = __webpack_public_path__ + "static/media/blrss4.577e6347.png";